import {
    SearchFilter,
    SearchInputUnit,
    SearchSort
} from '@adobe/magento-storefront-events-sdk/dist/types/types/schemas'

export const updateSearchInputCtx = (
    searchUnitId: string,
    searchRequestId: string,
    phrase: string,
    filters: Array<SearchFilter>,
    pageSize: number,
    currentPage: number,
    sort: Array<SearchSort>
): void => {
    let mse

    if (typeof window !== 'undefined') {
        mse = window.magentoStorefrontEvents
    }

    if (!mse) {
        // don't break search if events are broken/not loading
        return
    }

    const searchInputCtx = mse.context.getSearchInput() ?? { units: [] }

    // create search input unit
    const searchInputUnit: SearchInputUnit = {
        searchUnitId,
        searchRequestId,
        queryTypes: ['products', 'suggestions'],
        phrase,
        pageSize,
        currentPage,
        filter: filters,
        sort
    }

    // find search input unit index
    const searchInputUnitIndex = searchInputCtx.units.findIndex(
        (unit) => unit.searchUnitId === searchUnitId
    )

    // update search input unit
    if (searchInputUnitIndex < 0) {
        searchInputCtx.units.push(searchInputUnit)
    } else {
        searchInputCtx.units[searchInputUnitIndex] = searchInputUnit
    }

    mse.context.setSearchInput(searchInputCtx)
}
